export default __webpack_public_path__ + "static/media/pexels-canva-studio-3277806.cbe366c3.svg";